export default {
    PROSPECT: 'Prospect',
    CLAIMED: 'Claimed',
    ENGAGED: 'Engaged',
    READY: 'Ready',
    SAMPLES: 'Samples',
    SENT: 'Sent',
    FEEDBACK: 'Feedback',
    REJECTED: 'Rejected',
    HIRED: 'Hired',
    HIDDEN: 'Hidden',
    NONE: 'None',
};
